import { createQueryStringHook } from "../../../../stores/useQueryState";

export const useCriteria = createQueryStringHook("q", "");
